module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "detail-orders"
  }, [_c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-xs-8"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Order #" + _vm._s(this.$route.params.id))]), _vm._v(" "), _c('span', {
    staticClass: "detail-created"
  }, [_vm._v("\n                    Created : " + _vm._s(_vm.getOrdersDetail.createdAt) + " " + _vm._s(_vm.$t("planoList.by")) + " " + _vm._s(_vm.getOrdersDetail.createdBy.firstname) + "\n                    " + _vm._s(_vm.getOrdersDetail.createdBy.lastname) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "detail-modify"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("planoList.modified")) + " : " + _vm._s(_vm.getOrdersDetail.modifiedDate) + " " + _vm._s(_vm.$t("planoList.by")) + "\n                    " + _vm._s(_vm.getOrdersDetail.modifiedBy.firstname) + " " + _vm._s(_vm.getOrdersDetail.modifiedBy.lastname) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-4 page-prev"
  }, [_c('router-link', {
    staticClass: "btn btn-prev",
    attrs: {
      "to": {
        name: 'ListOrders'
      }
    }
  }, [_vm._v("Retour list orders")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12 order-md-1 detail-content"
  }, [(_vm.showMsgDetails) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("No response")])]) : _vm._e(), _vm._v(" "), (_vm.hideArray) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Contactez votre admin, Error " + _vm._s(_vm.getOrdersDetail.code))])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-hover table-detail"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/module/' + item.id
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.getTranslate(item.name).toLowerCase()) + " ")])], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(item.unit) + " * " + _vm._s(item.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currencyCustomPipe")(item.price, "en-US")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currencyCustomPipe")(item.totalPrice, "en-US")))])])
  }))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 col-xs-12 order-md-2 mb-4"
  }, [_c('div', {
    staticClass: "store-infos"
  }, [_c('h2', [_vm._v("Store Information")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col",
      "width": "100"
    }
  }, [_vm._v("Unit * QTY")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Unit price")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Total price")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6ada794","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/eStore/OrderDetail.vue
// module id = 3403
// module chunks = 0